<ng-content select="[slot='header']"></ng-content>
<ng-container *ngIf="open">
  <ng-content select="[slot='content']"></ng-content>
</ng-container>
